import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideFvElements = document.getElementsByClassName('splide__fv splide'); // right-image

if (splideFvElements.length) {
  let fvSlides = [];

  // FVスライダーの初期化
  for (let i = 0; i < splideFvElements.length; i++) {
    let fvSlide = new Splide(splideFvElements[i], {
      // ここにオプションを設定
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      breakpoints: {
        1025: {
        }
      }
    }).mount();

    fvSlides.push(fvSlide);
  }
}

const splideServiceElements = document.getElementsByClassName('splide__service splide');
if(splideServiceElements) {
  let serviceSlides = [];

  for(let i = 0; i < splideServiceElements.length; i++) {
    let serviceSlide = new Splide(splideServiceElements[i], {
      type: 'fade',
      rewind: true,
      arrows: true,
      pagination: false,
    }).mount();
  }
}
